import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {PageTitle} from '../../shared/components/page-title/page-title';
import {SettingsNavigationComponent} from './settings-navigation/settings-navigation';
import {TranslateSafePipe} from '../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    PageTitle,
    RouterOutlet,
    SettingsNavigationComponent,
    TranslateSafePipe,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css',
})
export class SettingsComponent {
}
